<template>
  <modal
    :show.sync="show"
    footerClasses="justify-content-center"
    ref="shiftFastCreator"
    headerClasses="bg-success text-light text-uppercase"
    bodyClasses="px-4"
    @close="closed"
  >
    <h4 slot="header" class="my-0">Selecciona un turno</h4>
    <div>
      <div
        class="tbody rounded mt-0"
        :class="tableData.length > 8 ? 'tbody--shadow' : ''"
      >
        <div class="shift-table overflow-auto rounded" ref="tableBody">
          <div
            v-for="(shift, i) in tableData"
            :key="i"
            class="d-flex border-bottom text-uppercase"
            :class="
              selectedShift.id === shift.id
                ? 'bg-success font-weight-bold pointer text-light shadow'
                : 'table-row'
            "
            @click="selectShift(shift)"
          >
            <p class="col-1 my-1">{{ i + 1 }}</p>
            <p class="text-truncate col-9 my-1">{{ shift.descripcionTurno }}</p>
            <div class="col-2 my-1"></div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button
        class="btn btn-success rounded-pill mr-1"
        @click="handleSave"
        :disabled="isNaN(`${selectedShift.id}`)"
      >
        seleccionar
      </button>
      <button
        class="btn btn-success rounded-pill ml-1"
        @click="showDetails"
        :disabled="isNaN(`${selectedShift.id}`)"
      >
        detalle
      </button>
    </div>
  </modal>
</template>

<script>
import { Badge, Modal } from "src/components/UIComponents";

export default {
  components: {
    Modal,
    Badge,
  },
  props: {
    showProp: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      default: () => {
        return [
          {
            id: 1,
            descripcionTurno:
              "Mock Shiftaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
          },
          {
            id: 2,
            descripcionTurno: "Mock Shift",
          },
          {
            id: 3,
            descripcionTurno:
              "Mock Shiftaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
          },
        ];
      },
    },
  },
  data() {
    return {
      selectedShift: false,
      show: false,
    };
  },
  watch: {},
  methods: {
    test() {
      // console.log(this.$refs.tableBody);
    },
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
    closed() {
      this.selectedShift = false
      this.$emit("closed");
      // console.log('closed')
    },
    handleSave(shift) {
      this.$emit("saveShiftSelection", this.selectedShift);
    },
    showDetails(shift) {
      this.$emit("showNewShiftDetails", this.selectedShift);
    },
    selectShift(shift) {
      if (shift === this.selectedShift) {
        this.selectedShift = false;
      } else {
        this.selectedShift = shift;
      }
    },
  },
  mounted() {},
};
</script>

<style>
.mwidth {
  max-width: 200px;
}
.shift-table {
  max-height: 250px;
}
.table-row:hover {
  text-shadow: 4px 4px 4px #00000042;
  cursor: pointer;
  background-color: rgba(184, 184, 184, 0.123);
}
</style>
